import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import colors from '../../../scss/colors';
import classes from './BaseSwipeableDrawer.module.scss';

const BaseSwipeableDrawer = ({ open = true, closeHandler, children, verticalScroll = 'auto', isDivider = false }) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={() => {}}
      onClose={closeHandler}
      sx={{
        '& .MuiPaper-root.MuiDrawer-paper': {
          backgroundColor: 'transparent',
          overflow: verticalScroll
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '22px',
          padding: '20px 0 24px 0',
          backgroundColor: colors.PAGE_BACKGROUND,
          borderRadius: '20px 20px 0 0'
        }}
      >
        {isDivider && <div className={classes.swiper} />}
        {children}
      </Box>
    </SwipeableDrawer>
  );
};

export default BaseSwipeableDrawer;
